<script>
    import {link, push} from "svelte-spa-router"
    import {fade} from "svelte/transition"
    import {clickOutside} from "../../public/assets/js/clickOutside";
    import {location} from "svelte-spa-router"
    import {showShoppingCart, shoppingCart, filter, showDialogLogin, showUserHeader, userData} from "../js/stores";
    import {API_URL} from "../../env";
    import updateUserData from "../js/updateUserData";
    import {addAlert} from "../js/alert";

    export let bannerText = ""

    function setShoppingCartButtonText(data) {
        if (data.length === 0) return 0
        if (data.length === 1) return data.length
        if (data.length < 5) return data.length
        return data.length
    }

    /** ÚČTY */
    // Account
    let expandTimeout = false

    function handleExpandChange() {
        if (!expandTimeout)
            showUserHeader.set(!$showUserHeader)
    }

    // Close user header
    function handleClickOutside() {
        expandTimeout = true
        showUserHeader.set(false)

        setTimeout(() => {
            expandTimeout = false
        }, 100)
    }

    location.subscribe(() => {
        showUserHeader.set(false)
    })

    // Logout
    async function logout() {
        const res = await fetch(API_URL + '/users/logout', {
            method: 'PUT',
            credentials: "include"
        })

        if (!res.ok) {
            // console.error(await res.json())
            return addAlert("danger", "Chyba", "Odhlásenie sa nepodarilo. Skúste to prosím znova.")
        }

        await updateUserData()

        await push("/")
    }
</script>

<section class="container-fluid">
    <header>
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-5 col-lg-4 d-flex justify-content-center justify-content-md-start mb-3 mb-md-0">
                    <a class="header-logo" href="/" use:link on:click={() => filter.set("")}>
                        <img src="assets/img/pneuin-logo.svg" alt="Logo PNEUIN.sk">
                    </a>
                </div>
                <div class="col-12 offset-md-2 col-md-5 offset-lg-4 col-lg-4 d-flex align-items-center justify-content-center justify-content-md-end">
                    {#if $userData !== null}
                        <div class="header-account">
                            <div class="ha-icon open" on:click={handleExpandChange}>
                                <i class="fas fa-fw fa-user"></i><i class="far fa-fw fa-chevron-{(($showUserHeader)? 'up' : 'down')}"></i>
                            </div>
                            {#if $showUserHeader}
                                <div class="ha-tooltip" transition:fade={{duration: 100}} use:clickOutside on:click_outside={handleClickOutside}>
                                    <div class="ha-content">
                                        <div class="ha-header">
                                            <div class="ha-image">
                                                <img src="assets/img/icons/pneuin_ikona_cierna.svg" alt="">
                                            </div>
                                            <div class="ha-name">
                                                <span>
                                                    {#if $userData.name}
                                                    {$userData.name + " " + ($userData.surname || "")}
                                                {:else}
                                                    {$userData.email}
                                                {/if}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="ha-list">
                                            <a href="#/ucet"><div class="ha-item">Môj účet</div></a>
                                            <a href="#/ucet/objednavky"><div class="ha-item">Moje objednávky</div></a>
                                        </div>
                                        <div class="ha-footer">
                                            <a on:click={logout}><i class="far fa-fw fa-arrow-right-from-bracket mr-2"></i>Odhlásiť sa</a>
                                        </div>
                                    </div>
                                </div>
                            {/if}
                        </div>
                    {:else}
                        <button type="button" class="btn btn-white" on:click={() => showDialogLogin.set({show: true, type: "login", data: {}})}>
                            <i class="fas fa-fw fa-user mr-2"></i>Prihlásiť sa
                        </button>
                    {/if}
                    <button type="button" class="btn btn-white btn-cart" on:click={() => showShoppingCart.set(!$showShoppingCart)}>
                        <i class="fas fa-fw fa-cart-flatbed-boxes mr-2"></i>Košík <span>{setShoppingCartButtonText($shoppingCart)}</span>
                    </button>
                </div>
            </div>
        </div>
    </header>

    {#if bannerText?.length > 1}
        <div class="header-alert">
            <p>{@html bannerText}</p>
        </div>
    {/if}

</section>

<style>
    header {
        padding: .75rem 0;
        margin-bottom: 2rem;
        background-color: var(--color-slate-50);
        border-bottom: 1px solid var(--color-slate-200);
    }
    header .header-logo {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    header .header-logo img {
        height: 2.5rem;
    }
    header .btn-cart {
        margin-left: 1rem;
    }
    header .btn-cart span {
        font-size: .8rem;
        height: 1.25rem;
        width: 1.25rem;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: .25rem;
        border-radius: 50%;
        background-color: #E65025;
        color: white;
        margin-left: .5rem;
    }
    .header-alert {
        background-color: #1A7ABA;
        color: white;
        text-align: center;
        font-family: Rubik, sans-serif;
        font-weight: 300;
        padding: 1.25rem 0;
    }
    .header-account .ha-icon {
        cursor: pointer;
        margin: 0.65rem 0;
    }
    .header-account .ha-icon.open ~ .ha-tooltip {
        display: block;
    }
    .header-account .ha-tooltip {
        position: absolute;
        right: 0;
        top: 4.5rem;
        background-color: white;
        border-radius: 1.5rem;
        z-index: 5;
        width: 20rem;
        display: none;
        box-shadow: 0 0 28px #00000029;
    }
    .header-account .ha-tooltip .ha-header {
        display: flex;
        align-items: center;
        padding: 0.8rem 1.3rem;
        border-bottom: 1px solid var(--color-slate-200);
    }
    .header-account .ha-tooltip .ha-name span {
        font-family: Rubik, sans-serif;
        font-weight: 700;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: var(--color-slate-700);
    }
    .header-account .ha-tooltip .ha-image {
        min-width: 2rem;
        width: 2rem;
        height: 2rem;
        background-color: #0000001A;
        border-radius: 50%;
        margin-right: .75rem;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .header-account .ha-tooltip .ha-image img {
        height: 1rem;
        width: 1rem;
        filter: opacity(0.5);
    }
    .header-account .ha-tooltip .ha-list {
        padding: 0.5rem 0;
    }
    .header-account .ha-tooltip .ha-list a {
        color: var(--color-slate-600) !important;
    }
    .header-account .ha-tooltip .ha-list .ha-item {
        padding: 0.5rem 1.3rem;
    }
    .header-account .ha-tooltip .ha-footer {
        border-top: 1px solid var(--color-slate-200);
    }
    .header-account .ha-tooltip .ha-footer a {
        display: block;
        padding: 1rem 1.3rem;
        color: red;
        cursor: pointer;
    }
    .header-account .ha-tooltip a:hover {
        text-decoration: underline;
    }
    @media (max-width: 767.98px) {
        .header-account .ha-tooltip {
            width: calc(100% - 2rem);
            right: 1rem;
        }
    }
</style>